import { create } from 'zustand';
import { fetchUserNotificationData, type AppNotification } from '../components/Preview/api';
import { v1PayloadToNotification, type V1SocketPayload } from '../utils/sockets';

interface RealtimeNotificationState {
  items: AppNotification[];
  fetchInitial: () => Promise<void>;
  pushFromPayload: (payload: V1SocketPayload) => void;
  markItemRead: (id: string) => void;
  removeItem: (id: string) => void;
  setItems: (items: AppNotification[]) => void;
  reset: () => void;
}

export const useRealtimeNotificationStore = create<RealtimeNotificationState>((set) => ({
  items: [],
  fetchInitial: async () => {
    try {
      const data = await fetchUserNotificationData();
      if (data === null) return;
      set({ items: data });
    } catch {
      /* keep existing list on fetch failure */
    }
  },
  pushFromPayload: (payload) => {
    const notif = v1PayloadToNotification(payload);
    if (!notif.message) return;
    set((state) => {
      if (notif.id && state.items.some((item) => item.id === notif.id)) {
        return state;
      }
      return { items: [notif, ...state.items] };
    });
  },
  markItemRead: (id) => {
    set((state) => ({
      items: state.items.map((item) => (item.id === id ? { ...item, isRead: true } : item)),
    }));
  },
  removeItem: (id) => {
    set((state) => ({
      items: state.items.filter((item) => item.id !== id),
    }));
  },
  setItems: (items) => set({ items }),
  reset: () => set({ items: [] }),
}));
